module.exports = __webpack_public_path__ + "img/photo.7d0dff5f.png";